export const FETCH_ALL_SUPPORT_USERS = 'FETCH_ALL_SUPPORT_USERS';
export const CREATE_SUPPORT_USER = 'CREATE_SUPPORT_USER';